import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource-variable/roboto';
import '@fontsource/fjalla-one';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

